import React from 'react'
import { toast } from 'react-toastify'

import { CloseButton } from './alerts.component.styles'

const displayAlert = ({ message, autoClose = true, type = 'default' }) => {
  const defaultOptions = {
    position: 'top-center',
    hideProgressBar: true,
    closeOnClick: false,
    draggable: false,
    closeButton: autoClose ? false : <CloseButton />,
  }

  const options = {
    ...defaultOptions,
    autoClose: autoClose ? 3000 : false,
  }

  const useDefault = type === 'default'

  return useDefault ? toast(message, options) : toast[type](message, options)
}

export { displayAlert }
